import styled from "styled-components";
import { color, } from "./color";

const { typeface, } = color;

type TypefaceVariant = "Xxsm" | "Sm" | "Md" | "Lg" | "Xl" | "Xxl" | "H1" | "H2" | "H3" | "H4" | "H5" | "H6";
type TypefaceType = "display" | "heading" | "paragraph" | "numeric";
type TypefaceColor = `#${string}`| keyof typeof typeface;

export const Typeface = styled.span<{$type?: TypefaceType; }>`
	font-family: ${({ $type }) => (
		$type === "display" ? "Space Grotesk" :
		$type === "heading" ? "Space Grotesk" :
		$type === "paragraph" ? "Inter" :
		$type === "numeric" ? "Space Mono" :
		"Inter"
	)};
	font-weight: 400;
`;

export const Xxsm = styled(Typeface)<{$variant?: TypefaceVariant; }>`
	font-size: 10px;
	line-height: 12px;
	color: ${({ $variant }) => color[$variant] || "red" };
`;

export const Xsm = styled(Typeface)<{$variant?: TypefaceVariant; }>`
	font-size: 12px;
	line-height: 10px;
	color: ${({ $variant }) => color[$variant] || "red" };
`;

export const Sm = styled(Typeface)<{$variant?: TypefaceVariant; }>`
	font-size: 14px;
	line-height: 20px;
	color: ${({ $variant }) => color[$variant] || "red" };
`;

export const Md = styled(Typeface)<{$variant?: TypefaceVariant; }>`
	font-size: 16px;
	line-height: 20px;
	color: ${({ $variant }) => color[$variant] || "red" };
`;

export const Lg = styled(Typeface)<{$variant?: TypefaceVariant; }>`
	font-size: 18px;
	line-height: 24px;
	color: ${({ $variant }) => color[$variant] || "red" };
`;

export const Xl = styled(Typeface)<{$variant?: TypefaceVariant; }>`
	font-size: 20px;
	line-height: 28px;
	color: ${({ $variant }) => color[$variant] || "red" };
`;

export const Xxl = styled(Typeface)<{$variant?: TypefaceVariant; }>`
	font-size: 24px;
	line-height: 32px;
	color: ${({ $variant }) => color[$variant] || "red" };
`;

export const H1 = styled.h1<{ $type?: TypefaceType; $color?: TypefaceColor; }>`
	font-family: ${({ $type }) => (
		$type === "display" ? "Space Grotesk" :
		$type === "heading" ? "Space Grotesk" :
		$type === "paragraph" ? "Inter" :
		$type === "numeric" ? "Space Mono" :
		"Inter"
	)};
	font-size: 60px;	
	line-height: 80px;
	color: ${({ $color = "heading" }) => $color.startsWith("#") ? $color : typeface[$color] ? typeface[$color] : "red" };
`;

export const H2 = styled.h2<{ $type?: TypefaceType; $color?: TypefaceColor; }>`
	font-family: ${({ $type }) => (
		$type === "display" ? "Space Grotesk" :
		$type === "heading" ? "Space Grotesk" :
		$type === "paragraph" ? "Inter" :
		$type === "numeric" ? "Space Mono" :
		"Inter"
	)};
	font-size: 48px;
	line-height: 60px;
	color: ${({ $color = "heading" }) => $color.startsWith("#") ? $color : typeface[$color] ? typeface[$color] : "red" };
`;

export const H3 = styled.h3<{ $type?: TypefaceType; $color?: TypefaceColor; }>`
	font-family: ${({ $type }) => (
		$type === "display" ? "Space Grotesk" :
		$type === "heading" ? "Space Grotesk" :
		$type === "paragraph" ? "Inter" :
		$type === "numeric" ? "Space Mono" :
		"Inter"
	)};
	font-size: 40px;
	line-height: 52px;
	font-weight: 200;
	color: ${({ $color = "heading" }) => $color.startsWith("#") ? $color : typeface[$color] ? typeface[$color] : "red" };
`;

export const H4 = styled(Typeface)<{$variant?: TypefaceVariant; }>`
	font-size: 36px;
	line-height: 48px;
	color: ${({ $variant }) => color[$variant] || "red" };
`;

export const H5 = styled(Typeface)<{$variant?: TypefaceVariant; }>`
	font-size: 24px;
	line-height: 32px;
	color: ${({ $variant }) => color[$variant] || "red" };
`;

export const H6 = styled(Typeface)<{$variant?: TypefaceVariant; }>`
	font-size: 20px;
	line-height: 28px;
	color: ${({ $variant }) => color[$variant] || "red" };
`;
